var _rect, _path, _rect2, _path2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecommendationsDm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 81,
    viewBox: "0 0 200 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.636719,
    width: 144,
    height: 20,
    rx: 10,
    fill: "#7871C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.1116L8.02504 10.6366L6.84171 11.8116L11.5 16.4699L21.5 6.46992L20.325 5.29492L11.5 14.1116Z",
    fill: "#353540"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30.6367,
    width: 200,
    height: 20,
    rx: 10,
    fill: "#DF8981"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 44.1116L8.02504 40.6366L6.84171 41.8116L11.5 46.4699L21.5 36.4699L20.325 35.2949L11.5 44.1116Z",
    fill: "#353540"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 60.6367,
    width: 164,
    height: 20,
    rx: 10,
    fill: "#CAD2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 74.1116L8.02504 70.6366L6.84171 71.8116L11.5 76.4699L21.5 66.4699L20.325 65.2949L11.5 74.1116Z",
    fill: "#353540"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecommendationsDm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recommendations-dm.f1ec5d1a713459d94f8800ad9e552a46.svg";